// import React, { useEffect, useState } from "react";
// import {
//   Checkbox,
//   FormControlLabel,
//   FormGroup,
//   Slider,
//   withStyles,
// } from "@material-ui/core";
// import { useDispatch } from "react-redux";
// import { addTempUser } from "../../store/loginActions";
// import Stepper from "./SurveyAnswer/Stepper";

// // Custom Checkbox Styles
// const CustomCheckbox = withStyles({
//   root: {
//     padding: "0px",
//     marginRight: "9px",
//     "&$checked": {
//       color: "#670001",
//     },
//   },
//   checked: {},
// })(Checkbox);

// // Custom Slider Styles
// const PrettoSlider = withStyles({
//   root: {
//     color: "#E77A45",
//     height: 6,
//   },
//   thumb: {
//     height: 24,
//     width: 24,
//     backgroundColor: "#E77A45",
//     border: "2px solid currentColor",
//     marginTop: -8,
//     marginLeft: -12,
//     "&:focus, &:hover, &$active": {
//       boxShadow: "inherit",
//     },
//   },
//   active: {},
//   track: {
//     height: 8,
//     borderRadius: 4,
//   },
//   rail: {
//     height: 8,
//     borderRadius: 4,
//     background: "#F2F2F3",
//     opacity: 1,
//   },
// })(Slider);

// // Dynamic Questions
// const questions = [
//   {
//     id: 1,
//     type: "checkbox",
//     question: "How do you like descriptions?",
//     options: ["Long", "Short"],
//   },
//   {
//     id: 2,
//     type: "checkbox",
//     question: "Tone of the content",
//     options: ["Straightforward", "Comedic", "Foodie"],
//   },
//   {
//     id: 3,
//     type: "permission",
//     question: "Location permission",
//     options: [],
//   },
//   {
//     id: 4,
//     type: "checkbox",
//     question: "Language",
//     options: ["English", "Hindi (Coming soon)"],
//   },
// ];

// const BotScreen = ({onGeoLocationClickHandler, setStepScreen}) => {
//   const dispatch = useDispatch();
//   const [step, setStep] = useState(1);

//   const [answers, setAnswers] = useState({});

//   useEffect(() => {
//     const initial = {};
//     questions.forEach((q, i) => {
//       if (q.type === "checkbox") {
//         const obj = {};
//         q.options.forEach((opt) => (obj[opt] = false));
//         initial[i] = obj;
//       } else if (q.type === "permission") {
//         initial[i] = 5; // default mid value
//       }
//     });
//     setAnswers(initial);
//   }, []);

//   const toggleAnswer = (index, option, type) => {
//     setAnswers((prev) => {
//       const updated = { ...prev };
//       const current = prev[index];

//       if (type === "checkbox") {
//         updated[index] = {
//           ...current,
//           [option]: !current[option],
//         };
//       }
//       return updated;
//     });
//   };

//   const setSliderAnswer = (index, value) => {
//     setAnswers((prev) => ({
//       ...prev,
//       [index]: value,
//     }));
//   };

//   return (
//     <div style={{ margin: "16px", marginTop: "0px", paddingTop: "16px" }}>
//       <div style={{ marginBottom: 22, fontSize: 24 }}>Train your bot</div>
//       {questions.map((q, i) => (
//         <div key={q.id} style={{ marginBottom: "24px" }}>
//           {/* Question Title */}
//           <div
//             className="exploreSurveyQuestion Satoshi"
//             style={{ marginBottom: "12px" }}
//           >
//             {q.question.split(" ").map((word, index) => (
//               <span key={index} style={{ animationDelay: `${index * 0.15}s` }}>
//                 {word}&nbsp;
//               </span>
//             ))}
//           </div>

//           {/* Options */}
//           {q.type === "checkbox" && (
//             <FormGroup className="botQuestionWrapper">
//               {q.options.map((opt) => (
//                 <FormControlLabel
//                   key={opt}
//                   control={
//                     <CustomCheckbox
//                       checked={answers[i]?.[opt] || false}
//                       onChange={() => toggleAnswer(i, opt, q.type)}
//                     />
//                   }
//                   label={opt}
//                   className="survey-option"
//                 />
//               ))}
//             </FormGroup>
//           )}

//           {q.type === "permission" && (
//             <div style={{ padding: "0px 16px" }}>
//               <button
//                 onClick={() => onGeoLocationClickHandler(true)}
//                 style={{
//                   padding: "8px 16px",
//                   backgroundColor: "#851d1e",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 4,
//                   cursor: "pointer",
//                 }}
//               >
//                 Location
//               </button>
//             </div>
//           )}
//            <div className="surveyBottomBar">
//             <div></div>
//             <div></div>
//               <button
//                 className={`payBottomModalContainerConfirmBtn Satoshi`}
//                 style={{ padding: 16 }}
//                 onClick={() => setStepScreen(3)}
//               >
//                 <div className="payBottomModalContainerConfirmBtnContent Satoshi">
//                   {step === questions.length ? "Submit" : "Next"}
//                 </div>
//               </button>
//             </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default BotScreen;

import React, { useState } from "react";
import "./botScreen.css";
import { ConfigProvider, Dropdown, Switch } from "antd";
import SegmentedControl from "../SegmentedControl/Index";
import DownArrowSvgIcon from "../../assets/ReactSvg/DownArrowSvgIcon";
import BotCuiratoIconSvg from "../../assets/ReactSvg/BotCuiratoIconSvg";
import SettingIcon1 from "../../assets/SettingIcon1.svg";
import SettingIcon2 from "../../assets/SettingIcon2.svg";
import SettingIcon3 from "../../assets/SettingIcon3.svg";
import SettingIcon4 from "../../assets/SettingIcon4.svg";
import SettingIcon5 from "../../assets/SettingIcon5.svg";

export default function BotScreen({
  onGeoLocationClickHandler,
  setStepScreen,
}) {
  const [contentLength, setContentLength] = useState("Short");
  const [contentTone, setContentTone] = useState("Expert");
  const [language, setLanguage] = useState("English");
  const [whether, setWhether] = useState("");
  const [locationEnabled, setLocationEnabled] = useState(false);

  const items = [];

  return (
    <ConfigProvider
    theme={{
      token: {
        colorPrimary: 'green',
      },
    }}
  >
    <div className="botScreen">
      <div className="botCard">
        {/* Logo */}
        <div className="logo-section">
          <BotCuiratoIconSvg />
          <div className="botTitle Satoshi">Cuirato</div>
          <div className="subtitle Satoshi">
            Cuirato generates content as per your food preferences
            and data submitted by experts on the app.
          </div>
        </div>
        <div className="botSettingActionWrapper">
          <p className="section-subtitle Satoshi">
            You can choose & setup how you'd like to see content:
          </p>

          <div style={{ borderTop: 0 }} className="botScreenrow">
            <div className="botLabelWrapper">
              <img src={SettingIcon1} alt="setting icon" />
              <div className="botLabel Satoshi">Content length</div>
            </div>
            <div className="button-group">
              <SegmentedControl
                options={["Long", "Short"]}
                value={contentLength}
                onChange={setContentLength}
              />
            </div>
          </div>

          <div className="botScreenrow">
            <div className="botLabelWrapper">
              <img src={SettingIcon2} alt="setting icon" />
              <div className="botLabel Satoshi">Content tone</div>
            </div>
            <div className="button-group">
              <SegmentedControl
                options={["Casual", "Expert", "Balance"]}
                value={contentTone}
                onChange={setContentTone}
              />
            </div>
          </div>

          <div className="botScreenrow">
            <div className="botLabelWrapper">
              <img src={SettingIcon3} alt="setting icon" />
              <div className="botLabel Satoshi">
                Weather based recommendation
              </div>
            </div>
            <span className="switch">
              <Switch
                size="small"
                rootClassName="botSwitchRoot"
                checkedChildren="On"
                unCheckedChildren="Off"
                defaultChecked
              />
            </span>
          </div>

          <div className="botScreenrow">
            <div className="botLabelWrapper">
              <img src={SettingIcon4} alt="setting icon" />
              <div className="botLabel Satoshi">Language (Hindi coming soon)</div>
            </div>
            <div>
              <Dropdown.Button
                className="botLanguageButtonWrapper"
                icon={<DownArrowSvgIcon />}
                menu={{ items }}
                onClick={() => {}}
              >
                English
              </Dropdown.Button>
            </div>
          </div>

          <div className="botScreenrow">
            <div className="botLabelWrapper">
              <img src={SettingIcon5} alt="setting icon" />
              <div className="botLabel Satoshi">Location based suggestion</div>
            </div>
            <span className="switch">
              <Switch
                size="small"
                rootClassName="botSwitchRoot"
                checkedChildren="On"
                unCheckedChildren="Off"
                defaultChecked
              />
            </span>
          </div>
        </div>
      </div>
      <button onClick={() => setStepScreen(3)} className="botDoneBtn">
        Done
      </button>
    </div>
    </ConfigProvider>
  );
}
